import { Injectable } from '@angular/core';
import { CallableNames, DbService } from '../../db.service';
import { Observable } from 'rxjs';
import { ILocationGroup } from 'src/app/shared/models/location-group/location.group.model';

export interface ILocationGroupCreateData {
  title: string;
  external: boolean;
  shortDescription: string | null;

  orgId: number;
};

interface ILocationGroupUpdateData {
  id: number;
  title: string;
  external: boolean;
  shortDescription: string | null;
};

@Injectable({
  providedIn: 'root'
})
export class LocationGroupsService {

  constructor(
    private dbService: DbService,
  ) { }

  public update(data: ILocationGroupUpdateData): Observable<ILocationGroup> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesLocationGroupsUpdate, data });
    return this.dbService.handleObs(obs);
  }

  public create(data: ILocationGroupCreateData): Observable<ILocationGroup> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesLocationGroupsCreate, data });
    return this.dbService.handleObs(obs);
  }

  public getAllLocationGroupsByOrgId(orgId: number): Observable<ILocationGroup[]> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesLocationGroupsGetAllByOrg, data: { orgId } });
    return this.dbService.handleObs(obs, { allSilent: true });
  }
}
